import { MDBCarousel, MDBCarouselItem } from "mdb-react-ui-kit";
import React from "react";

export default class LightBox extends React.PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      url: '',
      type: 0,
      status: false,
      suffix: null
    };
  }

  show(url, type = 0, suffix = null, init = 0) {
    this.setState({ url, type, status: true, suffix });
  }

  hide() {
    this.setState({ status: false, suffix: null });
  }

  render() {
    if (!this.state.status) {
      return null;
    }
    return (
      <div className="lightbox">
        <div className="mask" onClick={this.hide.bind(this)}></div>
        {this.state.type === 0 ? (
          typeof this.state.url === 'string' ? (
            <img src={this.state.url} alt="" />
          ) : (
            <MDBCarousel showIndicators touch={true} fade={window.matchMedia('(prefers-reduced-motion)').matches}>
              {this.state.url.map((url, index) => (
                <MDBCarouselItem
                  key={url}
                  src={url}
                  itemId={index + 1}
                  alt=""
                />
              ))}
            </MDBCarousel>
          )
        ) : (
          <video src={this.state.url} controls={true} autoPlay={true} />
        )}
        {this.state.suffix}
      </div>
    );
  }

}
